import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from '../../../environments/environment';
import { Parameter, ServerInBuiltError } from '../models/util/api-adapter-service-models';
import { AppRequest } from '../models/util/api-dto/request-models/app-request';
import { AppResponse } from '../models/util/api-dto/response-models/app-response';

@Injectable({
    providedIn: 'root',
})
export class ApiAdapterServiceService {
    private queryCount = 0;

    constructor(private httpClient: HttpClient) {}

    public executeApiRequest<T>(
        parameterList: Array<Parameter>,
        path: string,
        httpVerb: string,
        isFile: boolean = false
    ): Observable<any> {
        let url = path;
        let bodyData: {};
        let parameter: Parameter;
        let formData = new FormData();

        parameterList
            ?.filter((rt) => rt.in !== 'header')
            .forEach((requestType) => {
                parameter = parameterList.find(
                    (parameter) => parameter.name === requestType.name
                ) as Parameter;

                if (!parameter && requestType.required && requestType.in !== 'header') {
                    window.alert(
                        `Parameter "${requestType.name}" is required!, Try again with "${requestType.name}"`
                    );
                } else if (!parameter && !requestType.required) {
                    // continue;
                } else {
                    switch (requestType.in) {
                        case 'body': {
                            bodyData = parameter.value;
                            break;
                        }
                        case 'path': {
                            url = url.replace(`{${parameter.name}}`, parameter.value);
                            break;
                        }
                        case 'query': {
                            url = this.setQuery(parameter.name, parameter.value, url);
                            break;
                        }
                        case 'formData': {
                            formData = this.setFormData(parameter, formData);
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }

                parameter = undefined;
            });

        this.queryCount = 0;

        url = `${environment.api}${url}`;
        const appRequest: AppRequest<any> = {
            ...(parameterList?.[0]?.withoutKeyData ? bodyData : { data: bodyData }),
        };

        const headers = new HttpHeaders()
            .set('Authorization', 'Bearer ' + localStorage.getItem('telin.accessToken'))
            .set('Access-Control-Allow-Origin', '*');

        return this.httpClient
            .request<AppResponse<T>>(httpVerb, url, {
                body: !bodyData ? formData : appRequest,
                responseType: isFile ? ('blob' as 'json') : ('json' as 'json'),
                headers,
            })
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    if (err.error instanceof ErrorEvent) {
                        return of<AppResponse<any>>({
                            error: {
                                title: 'Network error!',
                                detail: err.message,
                                source: err.statusText,
                                status: err.status.toString(),
                            },
                            meta: {
                                code: err.status,
                                message: err.message,
                            },
                        });
                    }

                    return of<ServerInBuiltError>(err.error);
                })
            );
    }

    public uploadFileToS3(s3Url: string, file: File): Observable<any> {
        // Kita kirim raw binary/file dengan header Content-Type yang sesuai
        return this.httpClient.put(s3Url, file, {
            headers: { 'Content-Type': file.type },
        });
    }

    private setQuery(name: string, value: any, url: string): string {
        url = this.queryCount === 0 ? `${url}?${name}=${value}` : `${url}&${name}=${value}`;
        this.queryCount++;
        return url;
    }

    private setFormData(parameter: Parameter, formData: FormData): FormData {
        if (parameter.type === 'array') {
            for (let i = 0; parameter.value.length > i; i++) {
                formData.append(parameter.name, parameter.value[i], parameter.value[i].name);
            }
        } else {
            formData.append(parameter.name, parameter.value ? parameter.value : null);
        }
        return formData;
    }
}
